import MetricsListWidget from "@pages/Home/MetricsListWidget.component";
import PageStructure, { PageContent, PageContentHeader, PageContentInner, Pane, PaneContent } from "@pages/PageStructure.component";
import { useCallback, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { DraftOnly } from "@components/project/DraftModeRequired.component";
import { getPromptAnswer } from "@services/alert/alert.service";
import PipelineNodeList, { NodeGrid } from "@components/pipelineNodes/PipelineNodeList.component";
import { usePipelineNodes } from "@stores/data.store";
import { getGroupValueForNodeType } from "@services/modeling.service";
const EntitiesListPage = () => {
    const [search, setSearch] = useState('');
    const nodes = usePipelineNodes();

    return <PageStructure>
    <PageContent>
        <PageContentHeader>
            <div className="d-flex center-vertically">
                <div style={{width:'40%'}}>
                    <h1 className="mb-0"><span className="fw-light">Data Modeling / </span>Entities</h1>
                    <div className="text-muted font-13">Combine disparate source data into real-world business concepts like Customers, Orders, or Products.</div>
                </div>
                <div className="flex-1 ps-5 pe-5">
                    <input type="text" className="form-control input-rounded input-search" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)}/>

                </div>
                <div>
                    <Link to="/semantic-layer" className="btn btn-outline-primary me-1">
                        <i className="mdi mdi-share-circle"></i> Visual Editor
                    </Link>
                    <DraftOnly>
                        {/* <button className="btn btn-outline-primary" onClick={createNewMetric}>
                            <i className="mdi mdi-plus-thick"></i> New Metric
                        </button> */}
                    </DraftOnly>
                </div>
            </div>
        </PageContentHeader>
        <PageContentInner hasHeader>
            <Pane>
                <PaneContent>
                    <div className="p-4">
                        <NodeGrid searchQuery={search} nodeFilter={(node) => {
                            return getGroupValueForNodeType(node.node_type) == 'DATA_MODELING'
                        }}/>

                    </div>
                </PaneContent>
            </Pane>
        </PageContentInner>
        
    </PageContent>
</PageStructure>
}


export default EntitiesListPage;